import { useEventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";

export function useMatchedDiscountCapBps(): number {
  const { marketEventMatchedDiscountBps } = useEventsStore([
    "marketEventMatchedDiscountBps",
  ]);

  return marketEventMatchedDiscountBps === 0
    ? 500
    : marketEventMatchedDiscountBps;
}
